<template>
    <b-container>

    <div v-if="loading">
        <b-row>
            <b-col cols="10">
                <h1><b-link href="/tasks">Tasks</b-link> > Task #{{ task.autoid }}</h1>
            </b-col>
            <b-col cols="2"><b-button block :href="`/task/${task.id}/edit`">Edit</b-button></b-col>
        </b-row>
        <table class="table mb-0">
            <tbody>
                <tr>
                    <td><b-button size="sm" :variant="`${statuses[task.ref_status_id - 1].variant}`">
                            {{ statuses[task.ref_status_id - 1].label }}
                        </b-button></td>
                    <td><span :class="`${importances[task.ref_importance_id - 1].class}`">
                            <font-awesome-icon :icon="`${importances[task.ref_importance_id - 1].icon}`" />
                        </span> {{ task.subject }}
                    </td>
                    <td>Due Date: {{ task.date_due | onlyDate }}</td>
                    <td>Assigned To: <b-link :href="`/user/${assigned.id}`"><font-awesome-icon icon="fa-solid fa-user" /> {{
                        assigned.name_display
                    }}</b-link>
                    </td>
                </tr>
            </tbody>
        </table>
        <b-card class="mb-3">
            <span v-html="task.description"></span>
            <template #footer>
                Tasks created {{ task.date_due | fullDate }} by <b-link :href="`/user/${owner.id}`"><font-awesome-icon
                        icon="fa-solid fa-user" /> {{
                            owner.name_display
                        }}</b-link>

                <b-link v-if="task.policy_id !== null" :href="`/policy/${task.policy_id}`" class="mx-3"><font-awesome-icon
                        icon="fa-solid fa-link" /> Linked Policy </b-link>

                <b-link v-if="task.aspect_id !== null" :href="`/aspect/${task.aspect_id}`" class="mx-3"><font-awesome-icon
                        icon="fa-solid fa-link" /> Linked Aspect </b-link>


            </template>
        </b-card>
        <b-tabs content-class="mt-3">
            <b-tab title="Notes">
                <NotesList parent_type="task" :parent_value="task.ref_status_id" :ref_id="this.$route.params.id"
                    @notechange="task_change_handler" />
            </b-tab>
            <b-tab title="Attachments">
                <AttachmentsList :list="attachments" :ref_id="this.$route.params.id" ref_type="task" @update="attached" />
            </b-tab>
        </b-tabs>
        </div>
        <div v-else>Loading task...</div>
    </b-container>
</template>
<script>
import TaskDataService from "@/services/TaskDataService";
import AttachmentDataService from "@/services/AttachmentDataService";
import UserDataService from "@/services/UserDataService";
import ReferenceDataService from "@/services/ReferenceDataService";

export default {
    props: ["company"],
    components: {

        NotesList: () => import("../Note/NotesList.vue"),
        AttachmentsList: () => import("../Attachment/AttachmentsList.vue"),
    },
    data() {
        return {
            loading: false,
            task: {
                "autoid": 0,
                "id": "",
                "partent_task_id": null,
                "subject": "Loading",
                "description": "",
                "ref_status_id": 8,
                "ref_importance_id": 3,
                "set_private": 0,
                "opt_hours": 0,
                "opt_estimate": 0,
                "user_id": "",
                "user_id2": "",
                "policy_id": null,
                "aspect_id": null,
                "date_created": "",
                "date_due": "",
                "date_updated": "",
                "date_closed": null,
                "is_system": 0
            },
            task_change: false,
            attachments: [],
            attached_data: false,
            yesno: ['No', 'Yes'],
            assigned: false,
            owner: false,
            statuses: ReferenceDataService.status_codes(),
            importances: ReferenceDataService.importance_codes(),
        }
    },
    created() {

        TaskDataService.getById(this.$route.params.id).then((res) => {
            if (res && res.data) {
                this.task = res.data;
                this.loading = true;
            }
        }).catch((err) => {
            this.$emit("error", err);
        });

        AttachmentDataService.getByRef(this.$route.params.id).then((res) => {
            if (res && res.data) {
                this.attachments = res.data;
            }
        }).catch(() => {});

    },
    methods: {
        task_change_handler(value) {
            TaskDataService.update(this.task.id, { ref_status_id: value })
            this.task.ref_status_id = value
        },
        attached(data) {
            this.attached_data = data
        },
    },
    watch: {
        task: function () {
            if (this.task && this.task.user_id2) {
                UserDataService.getById(this.task.user_id2).then((res) => {
                    if (res && res.data) this.assigned = res.data;
                }).catch(() => {});
            }

            if (this.task && this.task.user_id) {
                UserDataService.getById(this.task.user_id).then((res) => {
                    if (res && res.data) this.owner = res.data;
                }).catch(() => {});
            }
        },
        attached_data: function () {
            AttachmentDataService.getByRef(this.$route.params.id).then((res) => {
                if (res && res.data) this.attachments = res.data;
            }).catch(() => {});
        }
    },

}
</script>